import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Tag } from "antd";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import ApiService from "../../../core/service/api-service";

export default function StudyAutoExportHistoryGrid({ studyId }) {
    const { t } = useTranslation();
    const { setData, setPaginationResult, queryModel, setDataGridProps, setLoading } = useDataGrid();

    const columns = [
        {
            title: t('Rule Name'),
            dataIndex: 'autoExportRuleName',
            key: 'ruleName',
            render: (text) => text || '-',
        },
        {
            title: t('Target AE Title'),
            dataIndex: 'targetAeTitle',
            key: 'targetAeTitle',
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                if (status === 1) {
                    return <Tag color='green'>{t('Success')}</Tag>;
                }
                return <Tag color='red'>{t('Error')}</Tag>;
            }
        },
        {
            title: t('Error Message'),
            dataIndex: 'errorMessage',
            key: 'errorMessage',
            ellipsis: true,
            render: (text) => text || '-'
        },
        {
            title: t('Exported At'),
            dataIndex: 'exportedAt',
            key: 'exportedAt',
            render: (text) => text ? new Date(text).toLocaleString() : '-'
        },
    ];

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: columns,
        });
    }, []);

    // Yükleme göstergesi TABLONUN İÇİNDE (silent: küresel gösterge susar) — bkz. StudyRequestGrid.
    const loadData = async () => {
        setLoading(true);
        try {
            const response = await ApiService.AutoExport.GetHistory({
                studyId: studyId,
                paginationQuery: queryModel.paginationQuery
            }, {silent: true});
            if (response.success) {
                setData(response.data);
                setPaginationResult(response.pagination);
            }
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, [queryModel.updateKey]);

    return (
        <DataGrid name={'study-auto-export-history'} />
    );
}
